<div class="header-bar">
    <div class="header-left">
      <div class="header-text">Integrations</div>
      <div class="divider"></div>
      <div class="search-box input-box">
        <svg-icon src="assets/svg/magnifier.svg"></svg-icon>
  
        <mat-form-field>
          <input matInput type="text" [formControl]="searchValueControl" />
        </mat-form-field>
      </div>
      <div class="divider"></div>
      <div class="filter">
        <button mat-button class="icon-btn" (click)="toggleFilterDialog()">
          <svg-icon src="assets/svg/filter.svg" svgClass="grey"></svg-icon>
        </button>
      </div>
    </div>
    <div class="header-center"></div>
    <div class="header-right">
      <button
        *ngIf="hasIntegrationsWrite"
        mat-button
        color="lightGreen"
        (click)="createNewIntegration()"
      >
        Create New Integration
      </button>
    </div>
  </div>
  
  <div class="integrations-list">
    <div class="container integrations-container">
      <div class="container-header no-bottom-border">
        <div class="text">Existing Integrations</div>
        <div class="options">
          <button
            *ngIf="hasIntegrationsDetail"
            mat-icon-button
            [matMenuTriggerFor]="integrationsMenu"
          >
            <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
          </button>
          <mat-menu
            class="mat-menu-elaphant vertical-menu"
            #integrationsMenu="matMenu"
          >
            <button
              *ngIf="hasIntegrationsWrite"
              class="icon-btn-w-text"
              mat-menu-item
              (click)="createNewIntegration()"
            >
              <svg-icon src="assets/svg/plus-circle-white.svg"></svg-icon>
              <span>Create New Integration</span>
            </button>
          </mat-menu>
        </div>
      </div>
  
      <div
        class="container-content"
        lhpeElementLoader
        #geofenceElementLoader="elementloader"
      >
        <table
          #geofencesTable
          mat-table
          [dataSource]="integrationDataSource"
          matSort
        >
  
          <ng-container matColumnDef="provider">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Provider
            </th>
            <td mat-cell *matCellDef="let element">{{ element.provider.name }}</td>
          </ng-container>

          <ng-container matColumnDef="external_id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              ID
            </th>
            <td mat-cell *matCellDef="let element">{{ element.external_id }}</td>
          </ng-container>
  
          <ng-container matColumnDef="options">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" class="options-cell">
              <button
                *ngIf="isTripistProvider(element)"
                mat-button
                (click)="launchPreview(element)"
                class="icon-btn"
                title="Launch Preview"
              >
                <svg-icon
                  src="assets/svg/view.svg"
                  [svgStyle]="{ 'width.px': 18, 'height.px': 12 }"
                  svgClass="lightBlue"
                ></svg-icon>
              </button>

              <button
                *ngIf="hasIntegrationsWrite && hasIntegrationsDetail"
                mat-button
                (click)="edit(element)"
                class="icon-btn"
              >
                <svg-icon
                  src="assets/svg/pencil.svg"
                  svgClass="lightBlue"
                ></svg-icon>
              </button>
              <div
                *ngIf="!(hasIntegrationsWrite && hasIntegrationsDetail)"
                class="empty-btn-space"
              ></div>
              <!--
              <button
                *ngIf="hasIntegrationsWrite"
                mat-button
                (click)="delete(element)"
                class="icon-btn"
              >
                <svg-icon
                  src="assets/svg/trashcan.svg"
                  [svgStyle]="{
                    'width.px': '15.25',
                    'height.px': '16.204'
                  }"
                  svgClass="lightBlue"
                ></svg-icon>
              </button>
              -->
              <div *ngIf="!hasIntegrationsWrite" class="empty-btn-space"></div>
            </td>
          </ng-container>
  
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="perPage" (page)="onPageChange($event)"></mat-paginator>
      </div>
    </div>
  </div>
  